export class Translation {
  private constructor(readonly locale: string, readonly translation: string) {}

  static of(locale: string, translation: string) {
    return new Translation(locale, translation);
  }
}
